import React, {Component} from 'react';
import Moment from "moment";
import Loading from "../../../Containers/Loading";
import * as AttendanceService from "../../../../services/Attendance/AttendanceService";

class AttendanceList extends Component {
    state = {
        isLoadingHide: false,
        attendanceList: [],
        isCreateClassPopupHide: true,
        sortSizeList: [
            {id: 0, text: "30개씩 보기", value: 30},
            {id: 1, text: "50개씩 보기", value: 50},
            {id: 2, text: "1000개씩 보기", value: 1000},
        ],
        sortSizeValue: 30,
        totalPages: 100,
        totalElements: 0,
        classroomNameUpdate: null
    }

    constructor(props) {
        super(props);
        this.curPage = 0;
    }

    componentDidMount = () => {
        this.getAttendanceList();
        this.setState({
            isLoadingHide: true
        });
    }

    getAttendanceList = () => {
        AttendanceService.getAttendance().then(response => {
            if (response !== null && response.status === 200 && response.data !== null && response.data.code === '0000') {
                this.setState({
                    attendanceList: response.data.data
                });
            } else {
                console.log(response);
                alert('SERVER ERROR');
            }
        }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    // searchAttendanceList = () => {
    //     const pageVO = {
    //         page: this.curPage,
    //         size: this.state.sortSizeValue,
    //         direction: 'DESC',
    //         sortBy: 'id',
    //     };
    //     AttendanceService.getAttendanceListByAttendingDateAndName(pageVO, this.searchDateValue, this.searchNameValue).then((response) => {
    //         console.error(response);
    //         if (response !== null && response.status === 200 && response.data !== null && response.data.code === '0000') {
    //             this.setState({
    //                 attendanceList: response.data.data.content,
    //                 totalPages: response.data.data.totalPages,
    //                 totalElements: response.data.data.totalElements
    //             });
    //         } else {
    //             alert(response.data.data);
    //         }
    //     }).catch((error) => {
    //         console.log(error);
    //         alert('SERVER ERROR');
    //     });
    // }

    // // input 데이터 저장
    // onDateInputValueChanged = (e) => {
    //     this.inputDateValue = e.target.value
    // }
    //
    // onNameInputValueChanged = (e) => {
    //     this.inputNameValue = e.target.value
    // }
    // // 검색
    // onSearch = () => {
    //     if (this.inputDateValue == null || this.inputDateValue.length === 0) {
    //         this.searchDateValue = 'null';
    //     } else {
    //         this.searchDateValue = this.inputDateValue;
    //     }
    //     if (this.inputNameValue == null || this.inputNameValue.length === 0) {
    //         this.searchNameValue = 'null';
    //     } else {
    //         this.searchNameValue = this.inputNameValue;
    //     }
    //     this.getAttendanceList();
    // }

    // onUpdatePage = (page) => {
    //     this.curPage = page;
    //     this.getAttendanceList();
    // }

    dateFormat = (date) => {
        if (date == null) {
            return '';
        } else {
            return Moment(date).format('YYYY-MM-DD hh:mm:ss')
        }
    }

    sortingChange = () => {
        console.log('sortChange');
    }

    render() {
        if (!this.state.isLoadingHide) {
            return (<Loading/>);
        }

        return (
            <div className="allconWrapper">
                <div className="contentsWrapper">
                    <div className="adminWrapper">
                        <div className="wrap-rCon">
                            <div className="wrap-rCon">
                                {/*<div className="wrap-top">*/}
                                {/*    <div className="box-rfix">*/}
                                {/*        <div className="wrap-select">*/}
                                {/*            <span></span>*/}
                                {/*            <select name="sortSizeValue" value={this.state.sortSizeValue}*/}
                                {/*                    onChange={this.sortingChange}>*/}
                                {/*                {this.state.sortSizeList.map((value, i) => {*/}
                                {/*                    return (*/}
                                {/*                        <option key={i} value={value.value}>{value.text}</option>*/}
                                {/*                    );*/}
                                {/*                })}*/}
                                {/*            </select>*/}
                                {/*        </div>*/}
                                {/*        <div className="wrap-select">*/}
                                {/*            <input className="ip-basic" type="text" placeholder="일자"*/}
                                {/*                   onChange={this.onDateInputValueChanged}/>*/}
                                {/*        </div>*/}
                                {/*        <div className="wrap-search">*/}
                                {/*            <input className="ip-basic" type="text" placeholder="이름"*/}
                                {/*                   onChange={this.onNameInputValueChanged}/>*/}
                                {/*            <a className="btn-sm yellow" onClick={() => this.onSearch()}>검색</a>*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                                <div className="tb-scroll">
                                    <table className="tb-basic">
                                        <colgroup>
                                            <col width="10%"/>
                                            <col width="15%"/>
                                            <col width="15%"/>
                                            <col width="30%"/>
                                            <col width="30%"/>
                                        </colgroup>
                                        <thead>
                                        <tr>
                                            <th>-</th>
                                            <th>아이디</th>
                                            <th>이름</th>
                                            <th>등원</th>
                                            <th>하원</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.attendanceList.map((attendance, i) =>
                                            <tr key={i}>
                                                <td>{attendance.id}</td>
                                                <td>{attendance.user.username}</td>
                                                <td>{attendance.user.name}</td>
                                                <td>{this.dateFormat(attendance['enterDate'])}</td>
                                                <td>{this.dateFormat(attendance['exitDate'])}</td>
                                            </tr>
                                        )}
                                        </tbody>
                                    </table>
                                </div>
                                {/*<PagingBtn currentPage={this.curPage} totalPages={this.state.totalPages}*/}
                                {/*           onUpdatePage={this.onUpdatePage}/>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AttendanceList;


// WEBPACK FOOTER //
// ./src/components/Pages/Attendance/AttendanceManagement/AttendanceList.js